// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"488c20e3","263":"45f852a2","272":"dd0577ae","292":"f27b165b","295":"4e6b28a3","313":"70316a3b","323":"36759e30","413":"da4be48d","649":"da050c4e","716":"9008f3f2","819":"b5ba2669","855":"e683a44f","907":"dc0acdc0"}[chunkId] + ".chunk.js";
};